<template>
  <div class="statistics">

    <div class="row">
      <div class="key">采购数量:</div>
      <div class="val">{{ statistics.c_num }}</div>
    </div>
    <div class="row" v-if="status == 0">
      <div class="key">国内运费:</div>
      <div class="val">{{ statistics.g_freight.toFixed(2) }}</div>
    </div>
    <div class="row" v-if="status == 0">
      <div class="key">应付款:</div>
      <div class="val">{{ statistics.payment.toFixed(2) }}</div>
    </div>
    <div class="row">
      <div class="key">客户付款:</div>
      <div class="val">{{ statistics.user_pay.toFixed(2) }}</div>
    </div>
    <div class="row" v-if="status >= 1">
      <div class="key">公司付款:</div>
      <div class="val">{{ statistics.payment.toFixed(2) }}</div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },
    status: { type: String },
  },
  computed: {
    statistics() {
      // console.log(this.checkedList);
      let total = {
        c_num: 0,
        g_freight: 0,
        payment: 0,
        user_pay: 0,
        company_freight: 0,
        drawing_amount: 0,
        balance: 0
      }
      this.checkedList.forEach(item => {
        total.c_num += item.order_detail.confirm_num - 0 //采购数量
        total.g_freight += item.order_detail.confirm_freight - 0 //国内运费
        total.payment += item.accountPayable - 0//应付款
        total.user_pay += item.order_detail.confirm_num * item.order_detail.confirm_price //客户付款
        total.company_freight += item.order_detail.confirm_dicker_price * item.order_detail.confirm_num + (item.order_detail.confirm_dicker_freight - 0)//公司付款
        // total.c_num +=item.order_detail.confirm_num //抽取金额
        // total.c_num +=item.order_detail.confirm_num //差额
      })
      total.user_pay += total.g_freight
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>